import { render } from "./validateMsg.vue?vue&type=template&id=5bb87356"
import script from "./validateMsg.vue?vue&type=script&lang=js"
export * from "./validateMsg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__